import { render, staticRenderFns } from "./WhatsNewScrolling.vue?vue&type=template&id=7c3e709e&scoped=true"
import script from "./WhatsNewScrolling.vue?vue&type=script&lang=js"
export * from "./WhatsNewScrolling.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewScrolling.vue?vue&type=style&index=0&id=7c3e709e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3e709e",
  null
  
)

export default component.exports